import { startsWith } from "ramda";
import { useCallback } from "react";
import { type PressEvent } from "react-aria";
import { useNavigate } from "react-router";
import type { To } from "react-router-dom";

import { routeWithBasename } from "@/app-utils/route.ts";

const useRouteTo = (): ((to: To, onPress?: PressEvent) => void) => {
  const navigate = useNavigate();
  return useCallback((to, onPress) => {
    const route = typeof to === "string" ? to : `${to.pathname}${to.search ? `${to.search}` : ""}`;
    if (startsWith("http", route)) {
      window.open(route, "_blank");
    } else if (onPress?.ctrlKey) {
      window.open(routeWithBasename(route), "_blank");
    } else {
      navigate(to);
    }
  }, []);
};

export { useRouteTo };
